import queryString from 'query-string';
import type { MouseEvent } from 'react';
import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import { authLoginRoute } from '#/modules/auth/routing/auth.routes';
import { showModal } from '#/zustand-stores/modalStore';

export function useLogin() {
  const location = useLocation();
  const [params] = useSearchParams();

  const defautlRedirectTo = location
    ? `${location.pathname}${location.search}`
    : '';
  const redirectTo = params.get('to') ?? defautlRedirectTo;

  const onClickLogin = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();

      showModal('LOGIN', {
        redirectTo,
        manualLogin: true,
      });
    },
    [redirectTo],
  );

  const loginLink = queryString.stringifyUrl({
    url: authLoginRoute.with({}),
    query: { to: redirectTo },
  });

  return { onClickLogin, loginLink };
}
